import { createFileRoute } from '@tanstack/react-router'
import { EcommerceAnalyticsPage } from './analytics/ecommerce'

// Dashboard's '/' route now shows the real ecommerce analytics (revenue, orders, funnel,
// cohorts, wishlists) instead of the old cleaning-business "Operations Overview" KPIs.
export const Route = createFileRoute('/(admin)/')({ component: EcommerceAnalyticsPage })
